import { Link } from "react-router-dom";
import Logo from "@/components/xuma/Logo";

export const Footer = () => (
  <footer className="bg-xuma-dark text-white/70">
    <div className="max-w-6xl mx-auto px-5 py-14 grid gap-10 sm:grid-cols-2 lg:grid-cols-5">
      <div className="sm:col-span-2">
        <Logo variant="light" size="md" />
        <p className="mt-4 max-w-sm text-sm leading-relaxed">
          Tu negocio en una tarjeta que trabaja por ti. Presenta, conecta y crece.
        </p>
        <p className="mt-6 font-heading text-lg text-white">Cada contacto suma.</p>
      </div>
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Producto</p>
        <ul className="space-y-2 text-sm">
          <li><a href="/#features" className="hover:text-white transition-colors">Funciones</a></li>
          <li><a href="/#pricing" className="hover:text-white transition-colors">Planes</a></li>
          <li><a href="/#faq" className="hover:text-white transition-colors">Preguntas</a></li>
        </ul>
      </div>
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Cuenta</p>
        <ul className="space-y-2 text-sm">
          <li><Link to="/login" className="hover:text-white transition-colors">Entrar</Link></li>
          <li><Link to="/register" className="hover:text-white transition-colors">Crear cuenta</Link></li>
        </ul>
      </div>
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Legal</p>
        <ul className="space-y-2 text-sm">
          <li><Link to="/legal" className="hover:text-white transition-colors">Centro Legal</Link></li>
          <li><Link to="/legal/terminos-y-condiciones" className="hover:text-white transition-colors">Términos y Condiciones</Link></li>
          <li><Link to="/legal/aviso-de-privacidad" className="hover:text-white transition-colors">Aviso de Privacidad</Link></li>
          <li><Link to="/legal/cookies" className="hover:text-white transition-colors">Cookies</Link></li>
          <li><Link to="/legal/reembolsos" className="hover:text-white transition-colors">Reembolsos</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-6xl mx-auto px-5 py-5 flex flex-col sm:flex-row gap-2 sm:items-center sm:justify-between text-xs text-white/40">
        <span>© {new Date().getFullYear()} Xuma Social Business Card. Todos los derechos reservados.</span>
        <span className="flex flex-wrap gap-x-4 gap-y-1">
          <Link to="/legal/terminos-y-condiciones" className="hover:text-white transition-colors">Términos</Link>
          <Link to="/legal/aviso-de-privacidad" className="hover:text-white transition-colors">Privacidad</Link>
          <Link to="/legal/cancelacion" className="hover:text-white transition-colors">Cancelación</Link>
          <a href="mailto:hola@xuma.social" className="hover:text-white transition-colors">hola@xuma.social</a>
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
